import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { ReactComponent as InformationCircle } from 'assets/icons/InformationCircleSmallIcon.svg';

import styles from './BalanceMessage.module.scss';

export const BalanceMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box className={styles.container}>
      <InformationCircle />
      <Typography variant="subtitle2">{t('financialPlan.openingBalanceSheets.balanceSheetMessage')}</Typography>
    </Box>
  );
};
